import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './ServiceUseGuideDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import imgSample from '../../../../images/user/img_notice_sample.jpg';
import imgSample01 from '../../../../images/user/img_notice_sample_01.jpg';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { formatDate } from '../../../../assets/js/comm';

import ToastPopup from '../../../../components/comm/ToastPopup';
import { useLocation, useNavigate } from 'react-router-dom';

const ServiceUseGuideDetail = () => {

    const location = useLocation();

    const { bbsMasId = null, bbsNttId = null } = location.state || {};

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [bbsDetail, setBbsDetail] = useState({}); //게시물 상세

    const retrieveBbsDetail = useCallback(async () => {
        const url = "/notices/retrieveBbsDetail";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { 
            headers: { Authorization: jToken } ,
        };
        await axiosApi.post(url, {bbsMasId : bbsMasId, bbsNttId : bbsNttId }, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) { 
                setBbsDetail(prev => ({...prev, ...res.data.result.bbsDetail}));
                console.log(res.data.result.bbsList)
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            console.error("게시물상세 결과 호출 중 오류  : ", err);
        })
    }, []);

    useEffect(() => {
        setTimeout(() => {
            retrieveBbsDetail();
        }, 50);
    },[])

    if(!bbsMasId || !bbsNttId) {
        alert('잘못된 접근 입니다.');
        return;
    }

    return (
        <>
            <HeadSub title="상세보기" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-pad="normal">


                    <div className={style['notice-detail-box']}>
                        <div className={style['head']}>
                            <p className={style['title']}>{bbsDetail.nttSj}</p>
                        </div>

                        <div className={style['mid']}>
                            <div className={style['content']}>
                                <div className={style['txt-box']}>
                                    <div
                                        className="ck-content desc"
                                        dangerouslySetInnerHTML={{ __html: bbsDetail.nttCn }}
                                    ></div>
                                </div>
                            </div>     
                        </div>
                    </div>
                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    ); 
};

export default ServiceUseGuideDetail;
